<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="550" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="text-body-1 text-sm-h6">
					<slot name="title">
					</slot>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-3">
					<div class="py-2"><v-divider></v-divider></div>
					<slot name="body">
					</slot>
				</v-card-text>
				<v-card-actions>
					<v-col class="py-0">
						<v-row class="justify-center">
							<v-col md="4" class="pr-1 pr-md-2">
								<v-btn color="grey darken-1" @click="modalHide" outlined class="text-capitalize font-weight-bold rounded-lg" height="45" block>{{cancelText}}</v-btn>
							</v-col>
							<v-col md="4" class="pl-1 pl-md-2">
								<v-btn :color="confirmColor" @click="save" depressed class="white--text text-capitalize font-weight-bold rounded-lg" height="45" block>{{ confirmText }}</v-btn>
							</v-col>
						</v-row>
					</v-col>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>

export default {
	data () {
		return {
			dialog: false,
			data: {},
		}
	},
	props: {
		confirmText: {
			type: String,
			default: "Ya"
		},
		cancelText: {
			type: String,
			default: "Tidak"
		},
		confirmColor: {
			type: String,
			default: "red lighten-1"
		},
	},
	methods: {
		modalShow(data) {
			this.dialog = true
			this.data = Object.assign({}, data)
		},
		modalHide() {
			this.dialog = false
		},
		save() {
			this.$emit('action', this.data)
			this.modalHide()
		}
	}
};
</script>